export default [{
  id: '1',
  name: '智图',
  provider: 'Geoq',
  url: 'http://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetPurplishBlue/MapServer/tile/{z}/{y}/{x}',
  maxZoom: 16,
  minZoom: 3,
  subdomains: [],
  corrdType: 'gcj02',
  source: '智图-GS(2019)758号',
  theme: 'dark',
  cover: 'zhitu'
}, {
  id: '2',
  name: '高德地图',
  provider: 'GaoDe',
  theme: 'light',
  url: 'https://webrd0{s}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}',
  maxZoom: 16,
  minZoom: 3,
  subdomains: ['1', '2', '3', '4'],
  source: '高德地图-GS(2019)6379号',
  cover: 'gaode'
}, {
  id: '3',
  name: '高德影像图',
  provider: 'GaoDe',
  theme: 'dark',
  url: 'https://webst0{s}.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}',
  maxZoom: 16,
  minZoom: 3,
  cover: 'gaodeyx',
  subdomains: ['1', '2', '3', '4'],
  source: '高德地图-GS(2019)6379号',
  checked: true,
  extend: [{
    url: 'https://webst0{s}.is.autonavi.com/appmaptile?style=8&x={x}&y={y}&z={z}'
  }]
}, {
  id: '4',
  name: '天地图影像图',
  provider: 'TianDiTu',
  theme: 'dark',
  url: 'https://t{s}.tianditu.gov.cn/DataServer?T=img_w&X={x}&Y={y}&L={z}&tk={key}',
  key: '8f7bb06b77e11cd20d3195f69beba3cc',
  maxZoom: 18,
  minZoom: 3,
  cover: 'tdtyx',
  subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
  source: '天地图-GS(2019)1719号',
  extend: [{
    url: 'https://t{s}.tianditu.gov.cn/DataServer?T=cia_w&X={x}&Y={y}&L={z}&tk={key}'
  }, {
    url: 'https://t{s}.tianditu.gov.cn/DataServer?T=ibo_w&X={x}&Y={y}&L={z}&tk={key}'
  }]
}, {
  id: '5',
  name: '天地图',
  provider: 'TianDiTu',
  theme: 'light',
  url: 'https://t{s}.tianditu.gov.cn/DataServer?T=vec_w&A0512_EMap&X={x}&Y={y}&L={z}&tk={key}',
  key: '8f7bb06b77e11cd20d3195f69beba3cc',
  maxZoom: 18,
  minZoom: 3,
  cover: 'tdt',
  subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
  source: '天地图-GS(2019)1719号',
  extend: [{
    url: 'https://t{s}.tianditu.gov.cn/DataServer?T=cta_w&X={x}&Y={y}&L={z}&tk={key}'
  }]
}, {
  id: '6',
  name: '天地图地形图',
  provider: 'TianDiTu',
  theme: 'light',
  url: 'https://t{s}.tianditu.gov.cn/DataServer?T=ter_w&A0512_EMap&X={x}&Y={y}&L={z}&tk={key}',
  key: '8f7bb06b77e11cd20d3195f69beba3cc',
  maxZoom: 18,
  minZoom: 3,
  cover: 'tdtdx',
  subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
  source: '天地图-GS(2019)1719号',
  extend: [{
    url: 'https://t{s}.tianditu.gov.cn/DataServer?T=cta_w&X={x}&Y={y}&L={z}&tk={key}'
  }]
} // {
//     id: '7',
//     name: '卫星云图',
//     provider: 'TianDiTu',
//     theme: 'dark',
//     url:
//         '',
//     key: '8f7bb06b77e11cd20d3195f69beba3cc',
//     maxZoom: 18,
//     minZoom: 3,
//     cover: "cloud",
//     source: '',
//     extend: [
//         {
//             url:
//                 'https://fy.istrongcloud.com/map/image_zoom/data/{z}/{x}/{y}'
//         }
//     ],
//     configUrl: "https://dmpapi.istrongcloud.com/h8_cloud_visible/tile/newest.json?apikey=fe37fb01e1bd4b53b24317beb20570ca"
// }
];